import {
  DialogDescription,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogClose,
  DialogTitle,
  Button,
  Dialog,
} from '@ui/components';
import { useTranslation } from 'react-i18next';

interface LogoutDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onLogout: () => void;
}

export const LogoutDialog = (props: LogoutDialogProps) => {
  const { isOpen, setIsOpen, onLogout } = props;
  const { t } = useTranslation();

  return (
    <Dialog onOpenChange={setIsOpen} open={isOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('NAVBAR.LOGOUT_DIALOG.TITLE')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{t('NAVBAR.LOGOUT_DIALOG.DESCRIPTION')}</DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="tertiary" type="button" size="large" wide>
              {t('NAVBAR.LOGOUT_DIALOG.CANCEL')}
            </Button>
          </DialogClose>
          <Button onClick={() => onLogout()} size="large" wide>
            {t('NAVBAR.LOGOUT_DIALOG.LOGOUT')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
